export default __webpack_public_path__ + "static/media/relatoriodeobras.30047f48.png";